<template>
  <div>
    <el-container class="contenBox">
      <el-header>
        <Header @collapsemenu="collapsemenu" :flag="1" :collapse="collapse" />
      </el-header>
      <el-container>
        <el-aside width="auto">
          <el-col>
            <el-menu
              :default-active="activeMenu"
              background-color="#f2f4f5"
              text-color="#333333"
              active-text-color="#666666"
              :collapse="collapse"
              collapse-transition
              class="el-menu-vertical-demo"
              :unique-opened="true"
              router
              @click.native.stop
            >
              <!-- 企业中心 -->
              <el-menu-item index="/enterprise">
                <span class="menuitem_line"></span>
                <i class="icon-name">
                  <img src="@/assets/images/enterprise_ center_icon.png" width="25px" height="25px" />
                </i>
                <span slot="title">企业中心</span>
              </el-menu-item>
              <!-- 账户信息管理 -->
              <el-menu-item index="/enterprise/accountInformation">
                <span class="menuitem_line"></span>
                <i class="icon-name">
                  <img src="@/assets/images/enterprise_ user_icon.png" width="25px" height="25px" />
                </i>
                <span slot="title">账户信息管理</span>
              </el-menu-item>               
              <!-- <el-submenu index="/accountInformation">
                <template slot="title">
                  <span class="menuitem_line"></span>
                  <i class="icon-name">
                    <img src="@/assets/images/enterprise_ user_icon.png" width="25px" height="25px" />
                  </i>
                  <span>账户信息管理</span>
                </template>
                <el-menu-item index="/enterprise/accountInformation">企业账户信息</el-menu-item>
              </el-submenu> -->
              <!-- 我的兑付 -->
              <el-menu-item index="/enterprise/exchangelist">
                <span class="menuitem_line"></span>
                <i class="icon-name">
                  <img src="@/assets/images/enterprise_ redemption_icon.png" width="25px" height="25px" />
                </i>
                <span slot="title">我的兑付</span>
              </el-menu-item>                       
              <!-- <el-submenu index="3">
                <template slot="title">
                  <span class="menuitem_line"></span>
                  <i class="icon-name">
                    <img src="@/assets/images/enterprise_ redemption_icon.png" width="25px" height="25px" />
                  </i>
                  <span>我的兑付</span>
                </template>
                <el-menu-item index="/enterprise/exchangelist">兑付列表</el-menu-item>
              </el-submenu> -->
              <!--最终核准兑付金额 -->
              <el-menu-item index="/enterprise/qyEndHzdfje">
                <span class="menuitem_line"></span>
                <i class="icon-name">
                  <img src="@/assets/images/enterprise_ complaint_icon.png" width="25px" height="25px" />
                </i>
                <span slot="title">最终核准兑付金额</span>
              </el-menu-item>                 
              <!-- 我的收藏 -->
              <el-menu-item index="/enterprise/collectionEnterprise">
                <span class="menuitem_line"></span>
                <i class="icon-name">
                  <img src="@/assets/images/enterprise_ collection_icon.png" width="25px" height="25px" />
                </i>
                <span slot="title">我的收藏</span>
              </el-menu-item>                 
              <!-- <el-submenu index="4">
                <template slot="title">
                  <span class="menuitem_line"></span>
                  <i class="icon-name">
                    <img src="@/assets/images/enterprise_ collection_icon.png" width="25px" height="25px" />
                  </i>
                  <span>我的收藏</span>
                </template>
                <el-menu-item index="/enterprise/collectionEnterprise">收藏列表</el-menu-item>
              </el-submenu> -->
              <!-- 我的投诉 -->
              <!-- <el-submenu index="5">
                <template slot="title">
                  <span class="menuitem_line"></span>
                  <i class="icon-name">
                    <img src="@/assets/images/enterprise_ complaint_icon.png" width="25px" height="25px" />
                  </i>
                  <span>我的投诉</span>
                </template>
                <el-menu-item index="/enterprise/complaint">投诉列表</el-menu-item>
              </el-submenu> -->
            </el-menu>
          </el-col>
        </el-aside>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { getEnterpriseInfo } from '@/api/enterprise/index'
import Header from '@/components/Header'
export default {
  components: {
    Header
  },
  data() {
    return {
      // collapse是否折叠
      collapse: false,
      activeMenu: '/enterprise'
    }
  },
  created() {
    this.activeMenu = this.$route.path // 关键 通过他就可以监听到当前路由状态并激活当前菜单
    // 获取当前企业信息，看是否完善
    this.getEnterpriseInfo()
  },
  methods: {
    // 点击展开和折叠左侧菜单
    collapsemenu() {
      this.collapse = !this.collapse
    },
    // 获取账户信息方法
    async getEnterpriseInfo() {
      const res = await getEnterpriseInfo({
        tyshxydm: this.$store.state.user.tyshxydm
      })
      if (res.code === 200) {
        // console.log(res, 'res');
        let { data } = res
        // 目前判断纳税人、机构联系人、开户行名称是否为空，为空才会提示，后面可能还需要添加判断。
        if (!data.sh && !data.jglxr && !data.gskhh) {
          this.$message.warning('温馨提示；企业信息未完善，请先完善信息，再进行其他操作')
          this.$router.push('/enterprise/accountInformation')
        }
      }
    },
  },
  watch: {
    '$route.path': {
      handler: function (newPath) {
        this.activeMenu = newPath
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.contenBox {
  box-sizing: border-box;
  // position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
.el-header {
  padding: 0 30px 0 26.5px;
  color: #333;
  text-align: center;
  height: 79px !important;
  background: linear-gradient(to right, #3a76f9, #2d6cf9, #2a6af9);
  border: 1px solid #164f8a;
}

.el-aside {
  background: #f2f4f5;
  box-shadow: 0 1px 0 0 #d8d8d8;
  text-align: left;
}

.el-main {
  background-color: #ffffff;
  color: #ffffff;
  text-align: center;
  height: 100vh;
  padding: 10px 30px 20px 31px;
}
/* 加过渡给侧边导航*/
.el-aside {
  transition: width 0.25s;
  -webkit-transition: width 0.25s;
  -moz-transition: width 0.25s;
  -webkit-transition: width 0.25s;
  -o-transition: width 0.25s;
}

.el-menu-item {
  height: 67px;
}

.el-menu-item,
.el-submenu__title {
  span {
    font-weight: 400;
    font-size: 20px;
    line-height: 65px;
  }
  i {
    margin-left: 25px;
    margin-right: 27px;
  }
}

.el-meun .el-submenu.el-submenu__title:hover {
  background-color: #e4ebf6 !important;
}

.el-menu .el-menu-item.is-active {
  background-color: #e4ebf6 !important;
  :nth-child(1) {
    visibility: visible;
  }
}

.el-menu-vertical-demo .el-submenu.is-active.is-opened .el-submenu__title .menuitem_line {
  visibility: visible;
}

.el-submenu__title {
  &:hover {
    background-color: #e4ebf6 !important;
  }
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 309px;
}

::v-deep .el-menu-vertical-demo .el-menu-item {
  padding-left: 0px !important;
  &:hover {
    background-color: #e4ebf6 !important;
  }
}
::v-deep .el-menu-vertical-demo .el-submenu {
  .el-submenu__title {
    padding-left: 0px !important;
    height: 67px;
    &:hover {
      background-color: #e4ebf6 !important;
    }
  }
  .el-menu-item {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 30px;
    width: 280px;
    height: 48px;
    border-radius: 23.51px 0 0 24.49px;
    background: #e4ebf6;
    font-size: 18px;
  }
  &:hover {
    background-color: #e4ebf6 !important;
  }
}

// /* 更改箭头的样式为+和-号 */
::v-deep .el-menu-vertical-demo .el-submenu .el-submenu__title .el-submenu__icon-arrow.el-icon-arrow-down {
  content: url('~@/assets/images/open.png'); /* 替换展开时的箭头为 + 号 */
  margin-right: 30px;
}

::v-deep .el-menu-vertical-demo .el-submenu.is-opened .el-submenu__title .el-submenu__icon-arrow.el-icon-arrow-down {
  content: url('~@/assets/images/put_away.png'); /* 替换展开时的箭头为 - 号 */
  margin-right: 30px;
}

// 菜单栏激活时竖线
.menuitem_line {
  display: inline-block;
  width: 10px;
  height: 95%;
  background-color: rgb(79, 126, 247);
  visibility: hidden;
}
</style>
